module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/234.61443b32.png";